import styles from "./styles.module.less"

type Props = {
  href?: string
  onClick?: () => void
  children: React.ReactNode
}

export function RainbowButton({ href, onClick, children }: Props) {
  const Component = href ? "a" : "button";
  const componentProps = href ? { href } : { onClick };

  return (
    <Component {...componentProps} className={`${styles.btn} items-center rounded-lg`}>
      {children}
      <span className={`${styles.cutoutInner} rounded-lg bg-card`}>
        <span className={styles.text}>
          {children}
        </span>
      </span>
    </Component>
  );
}
